import React, { Component } from 'react';
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import Main from "../../layout/main";
import ForgortPasswordRequest from "../../components/forgot-password/forgot-password-request";
import ForgotPasswordOTP from "../../components/forgot-password/forgot-password-otp";
import ResetPassword from "../../components/forgot-password/reset-password";
class ForgotPasswordIn extends Component {
    state = {
        activeStep: 0,
        email: '',
    }
    completedForgotPassword = (step, email) => {
        this.setState({ activeStep: step, email: email })
        if (step === 3) {
            // toastr.success('Success', 'Password updated successfully');
        }
    }
    render() {
        return (
            <Main additionalClass_main="login">
                <section className="ebw__section--login h-100">
                    <Container className="ebw__entry ebw-entry__container--login d-md-flex align-items-center">
                        <Row className="ebw-entry__row ebw-entry__row--login">
                            <Col sm="12" md="7" lg="7" className="h-100 mx-auto pt-10 pt-md-0 pb-10 pb-md-0">
                                <div className="ebw-entry__content-rgt position-relative">
                                    {this.state.activeStep == 0 && <ForgortPasswordRequest completedForgotPassword={this.completedForgotPassword} />}
                                    {this.state.activeStep == 1 && <ForgotPasswordOTP completedForgotPassword={this.completedForgotPassword} email={this.state.email} />}
                                    {this.state.activeStep == 2 && <ResetPassword completedForgotPassword={this.completedForgotPassword} email={this.state.email} />}
                                    <div className="ebw-entry__other-options text-center">
                                        <div className="ebw-entry__other-register mt-5">
                                            <span className="ebw-entry__other-account">Already have an account?</span>
                                            <Link to="/login" className="ebw-entry__other-create ml-1">Login</Link>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </Main>
        );
    }
}

export default ForgotPasswordIn;